import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, switchMap } from 'rxjs';
import { FileInputComponent } from 'src/app/common/components/input-component/file-input/file-input.component';
import { SpinnerService } from 'src/app/common/components/spinner-load/spinner.service';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { FileUploadResponse } from 'src/app/common/models/dto/file-upload-response';
import { FileData } from 'src/app/common/models/file-data';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { FileManagerService } from 'src/app/core/components/upload-tool/services/file-manager.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';

@Component({
  selector: 'app-new-document-form',
  templateUrl: './new-document-form.component.html',
  styleUrls: ['./new-document-form.component.css']
})
export class NewDocumentFormComponent implements OnInit {

  @Input()
  tipiDocumento: TipoDocumento[];

  @Input()
  tipiProvenienza: Provenienza[];

  @Output()
  onReturnCallback = new EventEmitter<DocumentoAllegato[]>();

  formRequest: DocumentoAllegato;

  @ViewChild('uploadInput') uploadInput: ElementRef;
  @ViewChild('fileInputComponent') fileInputComponent: FileInputComponent;

  loading: boolean;
  isFolder: boolean = false;

  aggiungiDocumentoForm: FormGroup;
  private fileUploadedName: string;
  private fileToUpload: any;
  private valid_files: any[] = [];
  fileUploaded: boolean;
  fileUploadList: DocumentoAllegato[] = [];

  constructor(private campiForm: FormBuilder,private spinner: SpinnerService,private http: HttpClient , private fileManager: FileManagerService) { }

  ngOnInit() {
    this.createForm();
  }


  createForm() {
    if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
    this.formRequest = new DocumentoAllegato();
    this.formRequest.titolo = null;
    this.formRequest.tipoDocumento = null;
    this.formRequest.dataRiferimento = new Date().getTime();
    this.formRequest.provenienza = null;
    this.formRequest.tipoVisibilitaDocumento = null;
    this.aggiungiDocumentoForm = this.campiForm.group({
      titolo: [this.formRequest.titolo, Validators.required],
      provenienza: [this.formRequest.provenienza],
      tipoDocumento: [this.formRequest.tipoDocumento, Validators.required],
      tipoVisibilitaDocumento: [this.formRequest.tipoVisibilitaDocumento, Validators.required],
      contentType: [this.formRequest.contentType],
      dataRiferimento: [this.formRequest.dataRiferimento, Validators.required],
      note: [this.formRequest.note],
      fileupload: [''],
      nomeFile: [this.formRequest.nomeFile],
    });
  }


  onSearchChange(fileInput: any) {
    let files = fileInput;
    this.loading = true;
      if (files.length > 0) {
        this.spinner.show();
        //this.filesChangeEmiter.emit(files)
      }
      for (var i = 0; i <files.length; i++) {
        this.fileToUpload = files[i];
        this.valid_files.push(files[i]);
        this.uploadFile(this.fileToUpload, Number(i)==files.length-1).subscribe(res => {
          if(res && res.fileData){
            this.setFileDataRequest(res.fileData);
            this.fileUploaded = true;
            this.fileUploadedName = res.fileData.nomeFile;
            //this.onReturn.emit(res.fileData)
          }
        });
      }
      this.loading = false;
  };


  uploadFile(file: File, isLastOne?): Observable < FileUploadResponse > {


    return this.fileManager.getPayloadFile(file).pipe(
      switchMap((res) => this.getObsFileUploadResponse(res)));

    /* const formData = new FormData();
    formData.append('contenuto', file);
    formData.append('nomeFile', file.name); */
    //return this.http.post<FileUploadResponse>(this.getUrlUploadDocumento(), payload, {withCredentials: true,})


  }

  private getObsFileUploadResponse(payload: { fileData: {}; }): Observable<FileUploadResponse> {
    return this.http.post<FileUploadResponse>(this.getUrlUploadDocumento(), payload, { withCredentials: true, });
  }

  setFileDataRequest(fileData: FileData) {
    this.formRequest.refDocumentale = fileData.refDocumentale;
    let fileDaAllegare = new DocumentoAllegato();
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    fileDaAllegare.signedData = fileData.signedData ?? null;
    fileDaAllegare.algoritmoImprontaDocumento = fileData.algoritmoImprontaDocumento;
    fileDaAllegare.improntaDocumento = fileData.improntaDocumento;
    this.fileUploadList.push(fileDaAllegare);
  }

  getUrlUploadDocumento() {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_DOCUMENTO;
  }

  save() {
    if (this.fileUploadList.length) {
      this.fileUploadList.forEach(element => {
        element.titolo = this.formRequest.titolo;
        element.tipoDocumento = this.formRequest.tipoDocumento;
        element.dataRiferimento = this.formRequest.dataRiferimento;
        element.provenienza = this.formRequest.provenienza;
        element.versione = '1.0';
        if (this.formRequest.note) element.note = "" + this.formRequest.note;
      });
      this.onReturnCallback.emit(this.fileUploadList);
      this.fileUploadList = [];
    }
  }

  reset(){
    this.onReturnCallback.emit(undefined);
    this.formRequest = new DocumentoAllegato();
    if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
  }

}
